export const IOS_MOBILE_ACCEPTED_BROWSERS = [
  'Safari',
  'Safari Mobile',
  'Mobile Safari',
  'Chrome',
  'Chrome Mobile',
  'Chrome Headless',
  'Chrome WebView',
  'Chromium'
]

export const OS_ACCEPTED_TO_CUSTOM_MODAL = ['iOS']
